import React from 'react';
import { SurveyResults } from '@Models/SurveyResults';
import { LatestSurveyResult } from '@Models/LatestSurveyResult';

type State = {
    latestResult: LatestSurveyResult | null
};

export type LatestSurveyResultAction = {
    type: string;
}

const emptyState: State = {
    latestResult: null
}

type ContextType = State;

export const LatestSurveyResultContext = React.createContext<ContextType>(emptyState);

export function LatestSurveyResultContextProvider(props: { children: JSX.Element[] | JSX.Element, initialState?: State }) {
    return <LatestSurveyResultContext.Provider value={props.initialState || emptyState}>{props.children}</LatestSurveyResultContext.Provider>;
}
